import * as React from 'react'
import classNames from 'classnames'
import type { CommonDeps } from '../base/CommonDeps'
import type { WithCachedImageUrl } from '../image/WithCachedImage'

interface Props {
    deps: CommonDeps
    unitName: string
    imageUrl?: string
    withCachedImageUrl: WithCachedImageUrl
    className?: string
    /** If you don't supply anything it will say 'Report subject' by default */
    label?: string
    compact?: boolean
    onClick?: () => void
}

export class ReportSubject extends React.Component<Props, {}> {
    public render() {
        const { unitName, deps, className, compact, label, onClick } = this.props
        return (
            <div className={classNames('AppCore__ui__ReportSubject', { clickable: onClick != null })} onClick={onClick}>
                {this.props.withCachedImageUrl(this.props.imageUrl, (cachedImageUrl) => (
                    <zaptic-report-subject
                        class={className}
                        unit-name={unitName}
                        image-url={cachedImageUrl}
                        language={deps.language}
                        compact={compact}
                        label={label}
                    ></zaptic-report-subject>
                ))}
            </div>
        )
    }
}
